<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4JPgEd/tc-custom/9781771000062.jpg?1737058339143" alt="This image is the cover for the book Olive Odyssey"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Olive Odyssey
      </h1>
      <p class="bookDescription body article font2">
        <b>This Mediterranean travel memoir offers “an engaging mix of history, food travelogue, and botany lesson . . . There is much to enjoy here” (<i>Library Journal</i>).</b><br/>  <br/> Inspired by her Syrian forebears’ intimate relationship with the olive, Julie Angus embarks on a voyage around the Mediterranean to unlock the secrets of the fruit that meant so much to them. Accompanied by her husband and their ten-month-old son, Angus collects samples from ancient trees to determine where the first olive tree originated; feasts on inky black tapenades and codfish drizzled with olive oil, among many other delights; witnesses the harvesting of olives in Greece; and visits perhaps the oldest olive tree in the world, on Crete. The result is a fascinating history and biography of this most influential and irresistible fruit.<br/>  <br/><b>“It is a pleasure to try to keep up with this book; like its author, it covers an enormous amount of territory.” —Christopher Bakken, <i>Wall Street Journal</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julie Angus
      </h2>
      
      <p class="authorDescription body article">The first woman to row across the Atlantic Ocean from mainland to mainland, <B>Julie Angus</B> has also cycled across continents, rowed thousands of kilometers of coastlines and rivers, and organized an expedition that sailed the ancient Phoenician trading routes. The author of <I>Rowboat in a Hurricane,</I> she lives in Comox, British Columbia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Greystone Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4796efc2